import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { variant1, variant2, variant3, variant4, variant5 } from './constants';
import { useAppName } from '../../utils/sitecoreContext';
import getMappedFields from '../ModelCardWithTrims/service/getMappedFields';
import { SpecialOffersContextProvider } from './SpecialOffersContext';
import SpecialOffersList from './SpecialOffersList';
import useProvinceBannerVisibility from './hooks/useProvinceBannerVisibility';
const SpecialOffers = ({ fields }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const appName = useAppName();
    useProvinceBannerVisibility();
    if (!fields)
        return null;
    const mappedFields = getMappedFields(fields, appName);
    let variant = variant1;
    let vehicleType = '';
    switch (appName) {
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        case PSP_SITE_NAME:
            variant = variant3;
            vehicleType = (_e = (_d = (_c = (_b = (_a = mappedFields === null || mappedFields === void 0 ? void 0 : mappedFields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.vehicleType) === null || _e === void 0 ? void 0 : _e.name;
            break;
        case PE_SITE_NAME:
            variant = variant4;
            break;
        case MARINE_SITE_NAME:
            variant = variant5;
            break;
        default:
            break;
    }
    const modelItems = (_m = (_l = (_k = (_j = (_h = (_g = (_f = fields === null || fields === void 0 ? void 0 : fields.data) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.catalog) === null || _h === void 0 ? void 0 : _h.fields) === null || _j === void 0 ? void 0 : _j.models) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.items) !== null && _m !== void 0 ? _m : [];
    const models = modelItems
        .map(modelItem => {
        var _a, _b, _c, _d;
        return ({
            modelYear: (_c = (_b = (_a = modelItem === null || modelItem === void 0 ? void 0 : modelItem.modelYears) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.year) === null || _c === void 0 ? void 0 : _c.value,
            modelKey: (_d = modelItem === null || modelItem === void 0 ? void 0 : modelItem.detKey) === null || _d === void 0 ? void 0 : _d.value,
        });
    })
        .filter((model) => 'modelYear' in model && 'modelKey' in model && !!(model.modelYear && model.modelKey));
    return (_jsx(SpecialOffersContextProvider, { variant: variant, modelKeys: models, vehicleType: vehicleType, children: _jsx(SpecialOffersList, { fields: fields }) }));
};
export default SpecialOffers;
